export default "__VITE_ASSET__C6ROu8rL__"